import React from "react";
import { NavLink } from "react-router-dom";

function MyComponent(props) {
  const { auth, roles } = props;
  const hasUserRole = roles.includes(2001);

  if (auth.result.entID !== 0 && hasUserRole) {
    return (
      <NavLink
        to="/verify"
        className="inline-flex items-center rounded-md bg-blue-100 px-3 py-2 text-sm font-semibold text-blue-700 shadow-sm ring-1 ring-inset ring-blue-300 hover:bg-blue-200"
      >
        Verify
      </NavLink>
    );
  } else {
    // Render something else or nothing
    return (
      <>
        <NavLink
          to="/verify"
          className="inline-flex items-center rounded-md bg-blue-100 px-3 py-2 text-sm font-semibold text-blue-700 shadow-sm ring-1 ring-inset ring-blue-300 hover:bg-blue-200"
        >
          Verify
        </NavLink>

        <NavLink
          to="/units"
          className="inline-flex items-center rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
        >
          Get Unit
        </NavLink>
      </>
    );
  }
}

export default MyComponent;
